import React, { useContext } from 'react';
import { GlobalStyle } from '../../globalStyle';
import AppContext from '../context';
import { ContainerWrapper } from '../elements/ContainerElements';
import Footer from './Footer';
import { Nav } from './Nav';

export const Container = ({ children }) => {
  const { dark } = useContext(AppContext);
  return (
    <ContainerWrapper dark={dark}>
      <GlobalStyle dark={dark} />
      <Nav /> {children}
      <Footer />
    </ContainerWrapper>
  );
};
